/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Customs_ClassificationInputs */

const en_attribute_customs_classification = /** @type {(inputs: Attribute_Customs_ClassificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customs classification`)
};

/**
* | output |
* | --- |
* | "Customs classification" |
*
* @param {Attribute_Customs_ClassificationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_customs_classification = /** @type {((inputs?: Attribute_Customs_ClassificationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Customs_ClassificationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_customs_classification(inputs)
});